import {TConnectionFormValues} from "../constants/type/connection/connectionType";
import {clearAuthCookie, getRequest, hasActiveSession, postRequest, putRequest} from "../helpers/axios_helpers";
import {logoutUser} from "../features/user/userSlice";
import {useDispatch} from "react-redux";
import {clearDataCache} from "../features/cache/remoteDBCacheSlice";
import _ from "lodash";
import {getDataTableStates, initDataTableState} from "../features/datatable/dataTableSlice";

function AuthenticationService() {
   // const navigate = useNavigate();
    const dispatch = useDispatch();

    const onLogout = () => {
        // The token is an httpOnly cookie now: only the gateway can drop it.
        clearAuthCookie();
        window.localStorage.removeItem("tableStates");
        window.localStorage.setItem("countLoadingPage", '1');
        dispatch(clearDataCache());
        dispatch(logoutUser());
    }

    return {
        authentificateUser: async (data: TConnectionFormValues) => {
            return await postRequest("/public/auth/login/employee", {
                username: _.trim(data.username),
                password: _.trim(data.password)
            });
        },
        checkUserToken: ():boolean => {
            const dataTableStates = getDataTableStates() ?? [];
            dispatch(initDataTableState(dataTableStates));

            // The httpOnly cookie is the real session and is invisible to JS, so we
            // rely on the persisted login flag; a stale cookie surfaces as a 401 on
            // the next request and the interceptor logs the user out.
            if (hasActiveSession()) {
                return true ;
            }
            onLogout();
            return false ;
        },
        refreshOnLogout: (count:any) => {
            if(count == 1){
                window.localStorage.setItem('countLoadingPage', String(parseInt(count+1)));
                window.location.reload();
            }
            else {
                window.localStorage.removeItem('countLoadingPage');
            }
        },
        updateUserPassword: async (data:any) => {
            return await putRequest("/security/update/employee/motdepasse", {
                username: data.username,
                password: data.password,
                newPassword: data.newPassword
            });
        },
        checkUsernameAvailability: async (username: string) => {
            return await getRequest(
                `/security/update/username/availability?username=${encodeURIComponent(_.trim(username))}`
            );
        },
        updateUsername: async (data:any) => {
            return await putRequest("/security/update/username", {
                username: _.trim(data.username),
                password: data.password,
                newUsername: _.trim(data.newUsername)
            });
        }
        /*async authentificateUser(data: TConnectionFormValues): Promise<any> {
            return await postRequest("/public/auth/login/employee", {
                 username: data.username,
                 password: data.password
             });
        },*/
    };
}

export default AuthenticationService;
